"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cos2 = exports.sin2 = exports.pad = exports.round = void 0;
function round(value, decimals) {
    if (decimals === void 0) { decimals = 0; }
    var p = Math.pow(10, decimals);
    return Math.round(value * p) / p;
}
exports.round = round;
function pad(num, size) {
    var numStr = num.toString();
    while (numStr.length < size) {
        numStr = '0' + numStr;
    }
    return numStr;
}
exports.pad = pad;
function sin2(number) {
    return Math.sin(number) * Math.sin(number);
}
exports.sin2 = sin2;
function cos2(number) {
    return Math.cos(number) * Math.cos(number);
}
exports.cos2 = cos2;
